export default [
    {
        path: "/internal/schedule/list",
        name: "schedule-list",
        component: () => import("@/views/HR/Engineer/Schedule/Index.vue"),
        meta: { breadcrumb: { label: 'Schedule Planning', parent: 'service' } },
    },
    {
        path: "/internal/schedule/edit/:schedule_id",
        name: "schedule-edit",
        component: () => import("@/views/HR/Engineer/Schedule/Create.vue"),
        props: true,
        meta: { breadcrumb: { label: 'Schedule', parent: 'schedule-list' } },
    },
    {
        path: "/internal/schedule/create",
        name: "schedule-create",
        component: () => import("@/views/HR/Engineer/Schedule/Create.vue"),
        props: route => ({
            customer_id: route.query.customer_id,
            equipment_id: route.query.equipment_id,
        }),
        meta: { breadcrumb: { label: 'Create', parent: 'schedule-list' } },
    },
    {
        path: "/internal/schedule/calendar",
        name: "schedule-calendar",
        component: () => import("@/views/HR/Engineer/Schedule/Calendar.vue"),
        meta: { breadcrumb: { label: 'Calendar', parent: 'schedule-list' } },
    },
    {
        path: "/internal/schedule/:scheduleId",
        name: "schedule-detail",
        component: () => import("@/views/HR/Engineer/Schedule/Detail.vue"),
        props: true,
        meta: { breadcrumb: { label: 'Schedule', parent: 'schedule-list' } },
    },
];
